import {
  CreateConfigTimeWorkRequest,
  CreateConfigTimeWorkResponse,
  GetActionRequest,
  GetActionResponse,
  GetConfigTimeWorkResponse,
  UpdateConfigTimeWorkRequest,
} from '@/types/apis/config'

import axios from './axios'

const API_ENDPOINT = '/system'

export const getConfig = (): Promise<GetConfigTimeWorkResponse> => {
  return axios.get(API_ENDPOINT)
}

export const createConfig = (request: CreateConfigTimeWorkRequest): Promise<CreateConfigTimeWorkResponse> => {
  return axios.post(`${API_ENDPOINT}`, request)
}

export const updateConfig = (request: UpdateConfigTimeWorkRequest) => {
  return axios.put(`${API_ENDPOINT}`, request)
}

export const getAction = (request: GetActionRequest): Promise<GetActionResponse> => {
  return axios.get('/action-logs/all', { params: request })
}
